"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16LocationPinDisabledFill = function Svg16LocationPinDisabledFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.293 3.293a1 1 0 0 1 1.414 0L7.494 6.08A5.914 5.914 0 0 1 12 4c3.369 0 6 2.796 6 6.12 0 1.731-.726 3.507-1.516 4.95l4.223 4.223a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414zM14 10a2 2 0 0 0-3.677-1.09l2.768 2.767c.547-.357.909-.975.909-1.677z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M6 10.121c0 2.322 1.306 4.722 2.32 6.292a27.241 27.241 0 0 0 2.124 2.846l.042.048.012.014.005.005.002.003a2 2 0 0 0 2.99 0l.003-.003.004-.005.012-.014.042-.048.145-.17c.121-.143.291-.35.493-.605l.074-.094L6 10.12z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16LocationPinDisabledFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16LocationPinDisabledFill;
exports.default = _default;